import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import {
  IPolicyActivateRequest,
  IPolicyLookupRequest,
  IPolicyLookupResult,
  IPolicyRecord,
  IPolicyRequestOtpRequest,
} from "./policyActivation.interface";

/**
 * Self-service activation for ABIC policies that reached us without a usable phone number. None of
 * these three calls needs a logged-in user; steps 1 and 2 are gated by Turnstile instead, whose
 * token goes in the same `turn-stile-token` header the login flow uses.
 */
class PolicyActivationService {
  lookup(body: IPolicyLookupRequest, turnstileToken?: string) {
    return httpService.post<IPolicyLookupResult>(apiService.patient.insmartPolicyActivation.lookup, body, {
      headers: { "turn-stile-token": turnstileToken },
    });
  }

  requestOTP(body: IPolicyRequestOtpRequest, turnstileToken?: string) {
    return httpService.post<boolean>(apiService.patient.insmartPolicyActivation.requestOTP, body, {
      headers: { "turn-stile-token": turnstileToken },
    });
  }

  // Step 3 carries no Turnstile token on purpose: the OTP is the stronger proof, and the phone
  // number is the one the server kept from step 2 - resending it here would be ignored.
  activate(body: IPolicyActivateRequest) {
    return httpService.post<IPolicyRecord>(apiService.patient.insmartPolicyActivation.activate, body);
  }
}

export default new PolicyActivationService();
